import { OrderByType } from '../types/OrderByType';
import { SortByType } from '../types/SortByType';

export const OrderMap = {
  fromSortBy: (sortBy: SortByType): OrderByType => {
    switch (sortBy) {
      case SortByType.CREATED_AT_ASCEND:
      case SortByType.CREATED_AT_DESCEND:
        return 'created_at';
      case SortByType.UPDATED_AT_ASCEND:
      case SortByType.UPDATED_AT_DESCEND:
        return 'updated_at';
      default:
        return 'updated_at';
    }
  },
};
